import React from 'react';
import AppRoutes from '../routes';
import Header from '../components/ncici/header';
import Footer from '../components/ncici/footer';
import HomePage from '../pages/ncici/home_page';
import AboutPage from '../pages/ncici/about_page';


export default function NciciTemplate(props) {
    return (
        <React.Fragment>
            <Header />
            <AppRoutes
                homePage={HomePage}
                aboutPage={AboutPage}
            />
            <Footer />
        </React.Fragment>
    )
}